import Vue from 'vue'
import Router from 'vue-router'
import Centers from './views/Centers.vue'
import RegForm from './views/RegForm.vue'
import Success from './views/Success.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'centers',
      component: Centers,
    },
    {
      path: '/states/:state',
      name: 'state',
      component: Centers,
    },
    {
      path: '/success',
      name: 'success',
      component: Success,
    },
    {
      path: '/:centerId',
      name: 'reg-form',
      component: RegForm,
    },
  ]
})
